import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-maximize",
  "use": "icon_player-maximize-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-maximize\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M8 3H5l-1.99998.00015S3 4.46957 3 5v3m18 0V3.00005L19 3h-3M3 16v3l.00002 2H8m8 0h5v-5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol